import { apiVersion, getUserUrl } from './config';

export async function getUserTime() {
  const config = {
    url: `${getUserUrl(apiVersion)}/time/heartbeat`,
    method: 'POST',
    headers: {},
  };

  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 5000); // 5 秒超时

  try {
    const response = await fetch(config.url, {
      method: config.method,
      headers: config.headers,
      signal: controller.signal,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
  } catch (e) {
    console.log(e);
    throw { status: 408 };
  } finally {
    clearTimeout(timeout);
  }
}
